export default __webpack_public_path__ + "static/media/StartButton1.0290d73b.mp3";